import { usePaymentMethod } from "./PaymentMethodContext";

const useNeedsUpdate = () => {
  const { state } = usePaymentMethod();
  const { needsUpdate, needsUpdateReason } = state;
  const message = getNeedsUpdateMessage(needsUpdateReason);

  return { needsUpdate, message };
};

function getNeedsUpdateMessage(reason) {
  if (!reason || reason.length === 0) return null;

  switch (reason) {
    case "payment_provider":
      return "Needs updating";
    default:
      return "Needs updating";
  }
}

const useIsUnusable = () => {
  const { state } = usePaymentMethod();
  const { isUnusable, isUnusableReason } = state;
  const message = isUnusable ? getIsUnusableMessage(isUnusableReason) : null;

  return { isUnusable, message };
};

const getIsUnusableMessage = (reason) => {
  if (!reason || reason.length === 0) return null;

  switch (reason) {
    case "we_pay_is_dead":
      return "Needs updating";
    default:
      return "Needs updating";
  }
};

export { useIsUnusable, useNeedsUpdate };
